import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},


   // 房源管理
  {
    path: '',
    name: 'housing',
    component: Layout,
    redirect: '/housing',
    meta: {title: '房源管理', icon: 'login-mall'},
    children: [{
      path: 'housing',
      name: 'housing',
      component: () => import('@/views/housing/list'),
      meta: {title: '房源管理', icon: 'login-mall'}
      },{
        path: '/housing/addOrEdit',
        name: '/housing/addOrEdit',
        hidden: true,
        component: () => import('@/views/housing/add'),
        meta: {title: '新增房源', icon: 'product-list'}
      }
    ]
  },

  // 区域管理
  {
    path: '/area',
    name: 'area',
    component: Layout,
    redirect: '/area',
    meta: {title: '区域管理', icon: 'tree'},
    children: [{
      path: '',
      name: '',
      component: () => import('@/views/area/index'),
      meta: {title: '区域管理', icon: 'tree'}
      }
    ]
  },
  // 招聘设置
  {
    path: '/recruit',
    name: 'recruit',
    component: Layout,
    redirect: '/recruit',
    meta: {title: '招聘设置', icon: 'zp'},
    children: [{
      path: 'list',
      name: '/recruit/list',
      component: () => import('@/views/recruit/list'),
      meta: {title: '招聘设置', icon: 'zp'}
    },{
      path: 'add',
      name: '/recruit/add',
      hidden: true,
      component: () => import('@/views/recruit/add'),
      meta: {title: '招聘', icon: 'tree'}
      }
    ]
  },


  // 业务员管理
  // {
  //   path: '/salesman',
  //   name: 'salesman',
  //   component: Layout,
  //   redirect: 'salesman',
  //   meta: {title: '员工管理', icon: 'ums-role'},
  //   children: [{
  //     path: '',
  //     name: '',
  //     component: () => import('@/views/ums/admin2/index'),
  //     meta: {title: '员工管理', icon: 'ums-role'}
  //     // },{
  //     //   path: '/salesman/addOrEdit',
  //     //   name: '/salesman/addOrEdit',
  //     //   hidden: true,
  //     //   component: () => import('@/views/salesman/add'),
  //     //   meta: {title: '新增员工', icon: 'product-list'}
  //     }
  //   ]
  // },
]

export const asyncRouterMap = [
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '设置', icon: 'ums'},
    children: [
      // {
      //   path: 'admin',
      //   name: 'admin',
      //   component: () => import('@/views/ums/admin/list'),
      //   meta: {title: '员工管理', icon: 'ums-admin'}
      // },
      // {
      //   path: 'admin/addOrEdit',
      //   name: 'admin/addOrEdit',
      //   hidden: true,
      //   component: () => import('@/views/ums/admin/add'),
      //   meta: {title: '新增员工', icon: 'product-list'}
      // },
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '员工管理', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js